<table *ngIf="dataArr.length">
  <tr *ngFor="let item of dataArr">
    <td align="left">
      <u>{{ item.key }}</u
      >:
    </td>
    <td>{{ item.value }}</td>
  </tr>
</table>
